export default __webpack_public_path__ + "static/media/episod11.74a86081.png";